<template>
  <header class="app-header" v-bind:class="{ 'colored-app-header': coloredAppHeader }">
    <button class="float-left app-header-icon mdl-button mdl-js-button mdl-button--icon mr-24"
            v-on:click="close"
            v-if="!hideArrowBackBtn && !isBrowserView"
            v-mdl>
      <i class="material-icons">arrow_back</i>
    </button>

    <div class="app-header__header-row" v-bind:class="{ 'float-left': !isBrowserView, 'text-center': isBrowserView, 'w-100': isBrowserView }">
      <!-- Title -->
      <span class="app-header-title">{{ headerTitle }}</span>
    </div>

    <button class="float-right app-header-icon mdl-button mdl-js-button mdl-button--icon"
            v-on:click="close"
            v-if="!hideCloseBtn && !isBrowserView"
            v-mdl>
      <img src="/static/images/close-white-54.svg" v-if="coloredAppHeader">
      <img src="/static/images/close-black-54.svg" v-else>
    </button>

  </header>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { isNil } from 'lodash';

  export default {
    name: 'app-header',

    props: [
      'header-title',
      'hide-arrow-back-btn',
      'hide-close-btn',
      'colored-app-header',
    ],

    computed: {
      ...mapGetters([
        'getRouteQuery',
      ]),

      isBrowserView() {
        return isNil(this.getRouteQuery.source);
      },
    },

    methods: {
      close() {
        this.$mobile.closeWebView();
      },
    },
  };
</script>

<style lang="scss">
  .app-header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    padding: 12px;
    z-index: 1030;
    background-color: #fff;
    box-shadow: none;
    border-bottom: solid 0.6px #d5d5d5;

    * {
      color: rgba(0, 0, 0, 0.87);
    }

    .app-header__header-row {
      padding-left: 4px;
      overflow-x: hidden;
      width: 75%;

      .app-header-title {
        font-size: 20px;
        line-height: 32px;
        font-weight: 500;
        white-space: nowrap;
      }
    }

    .app-header-icon {
      img {
        padding: 4px;
      }
    }

    &.colored-app-header {
      background-color: #00c896;
      box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
      border-bottom: solid 0.6px #00c896;

      .app-header-title {
        color: #fff;
      }

      .app-header-icon>img {
        fill: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AppHeader.vue?8aa84dce